import Vue from 'vue';
import { Component, Prop, Vue as Vue$1, Watch } from 'vue-property-decorator';
import format from 'date-fns/format';
import Buefy, { ToastProgrammatic } from 'buefy';
import axios, { AxiosStatic } from 'axios';
import debounce from 'lodash/debounce';
import Component$1, { mixins } from 'vue-class-component';
import * as VeeValidate from 'vee-validate';
import { ValidationProvider, ValidationObserver, extend, localize } from 'vee-validate';
import { isEmpty } from 'lodash';
import parse from 'date-fns/parse';
import { email, numeric, required } from 'vee-validate/dist/rules';
import fr from 'vee-validate/dist/locale/fr.json';
import en from 'vee-validate/dist/locale/en.json';
import Moment from 'moment';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

let bfAccountMenu = class bfAccountMenu extends Vue {
    username() {
        return this.$store.state.user.username;
    }
    toggle(e) {
        e.target.closest('.account-menu').classList.toggle('open');
    }
    close(e) {
        let menu = e.target.closest('.account-menu');
        if (!menu.contains(e.relatedTarget)) {
            menu.classList.remove('open');
        }
    }
    get bossUrl() {
        let protocol = window.location.protocol;
        let host = window.location.host.replace(/^.*?\./, 'boss.');
        return `${protocol}//${host}`;
    }
    get passwordUrl() {
        return `${this.bossUrl}/auth/change_password`;
    }
    get logoutUrl() {
        return `${this.bossUrl}/auth/logout`;
    }
};
bfAccountMenu = __decorate([
    Component({})
], bfAccountMenu);
var script = bfAccountMenu;

/* script */
            const __vue_script__ = script;
            
/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-menu",attrs:{"tabindex":"-1"},on:{"focusout":_vm.close}},[_c('a',{staticClass:"account-menu__username",on:{"click":_vm.toggle}},[_c('span',{staticClass:"mdi mdi-account"}),_vm._v("\n    "+_vm._s(_vm.username())+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"account-menu__dropdown"},[_c('ul',{staticClass:"account-menu__links"},[_vm._t("default-links",[_c('li',[_c('a',{attrs:{"href":_vm.passwordUrl}},[_vm._v("Change Password")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":_vm.logoutUrl}},[_vm._v("Logout")])])]),_vm._v(" "),_vm._t("default")],2)])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* component normalizer */
  function __vue_normalize__(
    template, style, script$$1,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script$$1 === 'function' ? script$$1.options : script$$1) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfAccountMenu.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfAccountMenu$1 = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

let bfAlert = class bfAlert extends Vue {
};
__decorate([
    Prop({ required: true, default: 'is-info' }),
    __metadata("design:type", String)
], bfAlert.prototype, "type", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], bfAlert.prototype, "hasIcon", void 0);
__decorate([
    Prop({ default: 'info' }),
    __metadata("design:type", String)
], bfAlert.prototype, "icon", void 0);
bfAlert = __decorate([
    Component({})
], bfAlert);
var script$1 = bfAlert;

/* script */
            const __vue_script__$1 = script$1;
            
/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bf-alert",class:_vm.type},[(_vm.hasIcon)?_c('span',{staticClass:"material-icons-outlined"},[_vm._v("\n    "+_vm._s(_vm.icon)+"\n  ")]):_vm._e(),_vm._v(" "),_vm._t("alert-text")],2)};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* component normalizer */
  function __vue_normalize__$1(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfAlert.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfAlert$1 = __vue_normalize__$1(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

let bfContentHeader = class bfContentHeader extends Vue {
};
__decorate([
    Prop(),
    __metadata("design:type", String)
], bfContentHeader.prototype, "title", void 0);
bfContentHeader = __decorate([
    Component({})
], bfContentHeader);
var script$2 = bfContentHeader;

/* script */
            const __vue_script__$2 = script$2;
            
/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-header"},[_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-left content-title"},[_c('div',{staticClass:"level-item"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n        "),_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"level-right content-buttons"},[_vm._t("default")],2)]),_vm._v(" "),_c('hr')])};
var __vue_staticRenderFns__$2 = [];

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* component normalizer */
  function __vue_normalize__$2(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfContentHeader.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfContentHeader$1 = __vue_normalize__$2(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

let bfPageHeader = class bfPageHeader extends Vue {
};
__decorate([
    Prop(),
    __metadata("design:type", String)
], bfPageHeader.prototype, "title", void 0);
bfPageHeader = __decorate([
    Component({})
], bfPageHeader);
var script$3 = bfPageHeader;

/* script */
            const __vue_script__$3 = script$3;
            
/* template */
var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-left page-title"},[_c('div',{staticClass:"level-item"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n        "),_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"level-right page-buttons"},[_vm._t("default")],2)]),_vm._v(" "),_c('hr')])};
var __vue_staticRenderFns__$3 = [];

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* component normalizer */
  function __vue_normalize__$3(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfPageHeader.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfPageHeader$1 = __vue_normalize__$3(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    undefined,
    undefined
  );

let bfPanel = class bfPanel extends Vue {
};
__decorate([
    Prop(),
    __metadata("design:type", String)
], bfPanel.prototype, "title", void 0);
bfPanel = __decorate([
    Component({})
], bfPanel);
var script$4 = bfPanel;

/* script */
            const __vue_script__$4 = script$4;
            
/* template */
var __vue_render__$4 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bf-panel"},[_c('div',{staticClass:"bf-panel-title",class:{level: _vm.$slots.buttons}},[_c('div',{staticClass:"title is-4",class:{'level-left': _vm.$slots.buttons}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n      "),_vm._t("title")],2),_vm._v(" "),(_vm.$slots.buttons)?_c('div',{staticClass:"level-right"},[_vm._t("buttons")],2):_vm._e()]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"bf-panel-content"},[_vm._t("default")],2)])};
var __vue_staticRenderFns__$4 = [];

  /* style */
  const __vue_inject_styles__$4 = undefined;
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* component normalizer */
  function __vue_normalize__$4(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfPanel.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfPanel$1 = __vue_normalize__$4(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    undefined,
    undefined
  );

let bfSectionHeader = class bfSectionHeader extends Vue {
};
__decorate([
    Prop(),
    __metadata("design:type", String)
], bfSectionHeader.prototype, "title", void 0);
bfSectionHeader = __decorate([
    Component({})
], bfSectionHeader);
var script$5 = bfSectionHeader;

/* script */
            const __vue_script__$5 = script$5;
            
/* template */
var __vue_render__$5 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header"},[_c('div',{staticClass:"level"},[_c('div',{staticClass:"level-left section-title"},[_c('div',{staticClass:"level-item"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n        "),_vm._t("title")],2)]),_vm._v(" "),_c('div',{staticClass:"level-right section-buttons"},[_vm._t("default")],2)]),_vm._v(" "),_c('hr')])};
var __vue_staticRenderFns__$5 = [];

  /* style */
  const __vue_inject_styles__$5 = undefined;
  /* scoped */
  const __vue_scope_id__$5 = undefined;
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* component normalizer */
  function __vue_normalize__$5(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfSectionHeader.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfSectionHeader$1 = __vue_normalize__$5(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    undefined,
    undefined
  );

let bfFormatDate = class bfFormatDate extends Vue {
    formatDatetime() {
        return format(this.date, this.dateFormat);
    }
};
__decorate([
    Prop({ required: true, type: Date }),
    __metadata("design:type", Object)
], bfFormatDate.prototype, "date", void 0);
__decorate([
    Prop({ required: true, type: String }),
    __metadata("design:type", Object)
], bfFormatDate.prototype, "dateFormat", void 0);
bfFormatDate = __decorate([
    Component({})
], bfFormatDate);
var script$6 = bfFormatDate;

/* script */
            const __vue_script__$6 = script$6;
            
/* template */
var __vue_render__$6 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(_vm.formatDatetime())+"\n")])};
var __vue_staticRenderFns__$6 = [];

  /* style */
  const __vue_inject_styles__$6 = undefined;
  /* scoped */
  const __vue_scope_id__$6 = undefined;
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* component normalizer */
  function __vue_normalize__$6(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfFormatDate.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfFormatDate$1 = __vue_normalize__$6(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    undefined,
    undefined
  );

let bfFormatBoolean = class bfFormatBoolean extends Vue {
};
__decorate([
    Prop({ required: true, type: Boolean }),
    __metadata("design:type", Object)
], bfFormatBoolean.prototype, "booleanValue", void 0);
bfFormatBoolean = __decorate([
    Component({})
], bfFormatBoolean);
var script$7 = bfFormatBoolean;

/* script */
            const __vue_script__$7 = script$7;
            
/* template */
var __vue_render__$7 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("\n  "+_vm._s(_vm.booleanValue ? 'Yes' : 'No')+"\n")])};
var __vue_staticRenderFns__$7 = [];

  /* style */
  const __vue_inject_styles__$7 = undefined;
  /* scoped */
  const __vue_scope_id__$7 = undefined;
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* component normalizer */
  function __vue_normalize__$7(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfFormatBoolean.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfFormatBoolean$1 = __vue_normalize__$7(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    undefined,
    undefined
  );

var _a;
let bfForm = class bfForm extends Vue$1 {
    async onSubmit() {
        let submitButton = document.getElementById('submit-button-' + this.formId);
        let originalText = '';
        if (submitButton !== null) {
            originalText = submitButton.innerHTML;
            submitButton.disabled = true;
            submitButton.innerHTML = 'Please wait';
        }
        let response = {};
        if (this.$axios) {
            response = await this.$axios[this.method](this.action, this.formData);
        }
        else {
            response = await axios[this.method](this.action, this.formData);
        }
        if (submitButton !== null) {
            submitButton.disabled = false;
            submitButton.innerHTML = originalText;
        }
        if (response) {
            if (response.data.success) {
                ToastProgrammatic.open({
                    duration: 2500,
                    message: response.data.success,
                    type: 'is-success'
                });
                this.$emit('submit', response.data);
            }
            else {
                // set the error dictionary for the ValidationObserver on the form
                if (this.$refs.formRef && response.data.error_dict) {
                    this.$refs.formRef.setErrors(response.data.error_dict);
                }
                if (response.data.error) {
                    ToastProgrammatic.open({
                        duration: 5000,
                        message: response.data.error,
                        type: 'is-danger'
                    });
                }
                this.$emit('submit-error', response.data);
            }
            return true;
        }
    }
};
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], bfForm.prototype, "action", void 0);
__decorate([
    Prop({}),
    __metadata("design:type", typeof (_a = typeof Object !== "undefined" && Object) === "function" ? _a : Object)
], bfForm.prototype, "formData", void 0);
__decorate([
    Prop({
        default: () => {
            // Generates unique ID for submit button
            return Math.random()
                .toString(36)
                .substr(2, 10);
        }
    }),
    __metadata("design:type", Number)
], bfForm.prototype, "formId", void 0);
__decorate([
    Prop({ default: 'post' }),
    __metadata("design:type", String)
], bfForm.prototype, "method", void 0);
__decorate([
    Prop({ default: 'Save' }),
    __metadata("design:type", String)
], bfForm.prototype, "submitLabel", void 0);
bfForm = __decorate([
    Component({})
], bfForm);
var script$8 = bfForm;

/* script */
            const __vue_script__$8 = script$8;
            
/* template */

  /* style */
  const __vue_inject_styles__$8 = undefined;
  /* scoped */
  const __vue_scope_id__$8 = undefined;
  /* module identifier */
  const __vue_module_identifier__$8 = undefined;
  /* functional template */
  const __vue_is_functional_template__$8 = undefined;
  /* component normalizer */
  function __vue_normalize__$8(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "BaseForm.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var BaseForm = __vue_normalize__$8(
    {},
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    undefined,
    undefined
  );

var _a$1, _b;
const defaultEmptyText = 'No results found';
class AutoCompleteFieldObject$$1 {
    /**
     * Initialises the AutoCompleteFieldObject for a bfAutoCompleteSearchField.
     *
     * The bfAutoCompleteSearch Field is bound to this model, thus to propagate
     * changes to the object on the form; modelToUpdate and fieldToUpdate allow
     * bfAutoCompleteSearch to interact with the data in the same way as v-model
     * is used on other fields.
     * When a value is selected and AutoCompleteFieldObject.selected is updated,
     * that value is also updated on modelToUpdate.fieldToUpdate
     *
     * @param updateModel: indicates whether the model should be updated
     * @param modelToUpdate: the model to update
     * @param fieldToUpdate: the field to update
     */
    constructor(updateModel = false, modelToUpdate = null, fieldToUpdate = '') {
        this.data = [];
        this.emptyText = defaultEmptyText;
        this.isFetching = false;
        this.selected = {};
        this.model = '';
        this.updateModel = false;
        this.modelToUpdate = null;
        this.fieldToUpdate = '';
        this.updateModel = updateModel;
        this.modelToUpdate = modelToUpdate;
        this.fieldToUpdate = fieldToUpdate;
    }
    async makeRequest(axios$$1, requestUrl) {
        this.isFetching = true;
        const response = await axios$$1.get(requestUrl, { params: { q: this.model } });
        this.data = response.data;
        if (this.data.length === 0) {
            this.emptyText = defaultEmptyText;
        }
        this.isFetching = false;
    }
    async debouncedMakeRequest(axios$$1, requestUrl) {
        await this.makeRequest(axios$$1, requestUrl);
    }
}
__decorate([
    Debounce(500),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_a$1 = typeof AxiosStatic !== "undefined" && AxiosStatic) === "function" ? _a$1 : Object, String]),
    __metadata("design:returntype", typeof (_b = typeof Promise !== "undefined" && Promise) === "function" ? _b : Object)
], AutoCompleteFieldObject$$1.prototype, "debouncedMakeRequest", null);

class Crumb {
    constructor(title, link, external = false) {
        this.title = title;
        this.link = link;
        this.external = external;
    }
}

function Debounce(duration = 500) {
    // https://github.com/bvaughn/debounce-decorator
    return function decorator(target, key, descriptor) {
        return {
            configurable: true,
            enumerable: descriptor.enumerable,
            value: debounce(descriptor.value, duration)
        };
    };
}

let FormMixin = class FormMixin extends Vue {
};
__decorate([
    Prop({ required: true, type: String }),
    __metadata("design:type", String)
], FormMixin.prototype, "label", void 0);
__decorate([
    Prop(String),
    __metadata("design:type", String)
], FormMixin.prototype, "field", void 0);
__decorate([
    Prop(),
    __metadata("design:type", void 0)
], FormMixin.prototype, "value", void 0);
__decorate([
    Prop({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], FormMixin.prototype, "horizontal", void 0);
__decorate([
    Prop(String),
    __metadata("design:type", String)
], FormMixin.prototype, "message", void 0);
__decorate([
    Prop({ default: undefined, type: [String, Object] }),
    __metadata("design:type", Object)
], FormMixin.prototype, "validate", void 0);
__decorate([
    Prop({
        default: 'medium',
        type: String
    }),
    __metadata("design:type", String)
], FormMixin.prototype, "width", void 0);
FormMixin = __decorate([
    Component({})
], FormMixin);

let bfFormGroup = class bfFormGroup extends Vue$1 {
};
__decorate([
    Prop({ required: true, type: String }),
    __metadata("design:type", String)
], bfFormGroup.prototype, "label", void 0);
__decorate([
    Prop({ type: String }),
    __metadata("design:type", String)
], bfFormGroup.prototype, "field", void 0);
__decorate([
    Prop({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], bfFormGroup.prototype, "horizontal", void 0);
__decorate([
    Prop({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], bfFormGroup.prototype, "hideColon", void 0);
__decorate([
    Prop(String),
    __metadata("design:type", String)
], bfFormGroup.prototype, "message", void 0);
bfFormGroup = __decorate([
    Component({})
], bfFormGroup);
var script$9 = bfFormGroup;

/* script */
            const __vue_script__$9 = script$9;
            
/* template */
var __vue_render__$8 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{staticClass:"bf-form-group",attrs:{"label":("" + _vm.label + (_vm.hideColon ? '' : ':')),"horizontal":_vm.horizontal}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$8 = [];

  /* style */
  const __vue_inject_styles__$9 = undefined;
  /* scoped */
  const __vue_scope_id__$9 = undefined;
  /* module identifier */
  const __vue_module_identifier__$9 = undefined;
  /* functional template */
  const __vue_is_functional_template__$9 = false;
  /* component normalizer */
  function __vue_normalize__$9(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfFormGroup.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfFormGroup$1 = __vue_normalize__$9(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    undefined,
    undefined
  );

let bfAutocomplete = class bfAutocomplete extends mixins(FormMixin) {
    constructor() {
        super(...arguments);
        this.unselectedMessage = '';
    }
    updateEmptyText(emptyText) {
        this.emptyText = emptyText;
    }
    get formMessage() {
        return this.unselectedMessage === ''
            ? this.message
            : this.unselectedMessage;
    }
    optionSelected(event) {
        if (event === null) {
            this.unselectedMessage = 'Option not selected';
        }
        else {
            this.unselectedMessage = '';
        }
    }
    loadSelected(selected) {
        this.$refs.autocompleteRef.setSelected(selected);
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Object)
], bfAutocomplete.prototype, "dataField", void 0);
__decorate([
    Prop({ default: 'No results found' }),
    __metadata("design:type", String)
], bfAutocomplete.prototype, "emptyText", void 0);
__decorate([
    Watch('emptyText'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], bfAutocomplete.prototype, "updateEmptyText", null);
bfAutocomplete = __decorate([
    Component$1({
        components: { bfFormGroup: bfFormGroup$1, ValidationProvider }
    })
], bfAutocomplete);
var script$a = bfAutocomplete;

/* script */
            const __vue_script__$a = script$a;
            
/* template */
var __vue_render__$9 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.readonly)?_c('bf-form-group',{staticClass:"bf-autocomplete",attrs:{"field":_vm.field,"label":_vm.label,"horizontal":_vm.horizontal,"message":_vm.formMessage}},[_c('ValidationProvider',{attrs:{"vid":_vm.field,"name":_vm.label,"rules":_vm.validate},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var invalid = ref.invalid;
var touched = ref.touched;
return [_c('b-autocomplete',_vm._g(_vm._b({ref:"autocompleteRef",class:{
                        invalid: invalid && touched,
                        'input-small': _vm.width === 'small',
                        'input-medium': _vm.width === 'medium',
                        'input-large': _vm.width === 'large'
                    },attrs:{"name":_vm.field,"value":_vm.value,"field":_vm.dataField},on:{"select":_vm.optionSelected}},'b-autocomplete',_vm.$attrs,false),_vm.$listeners),[_c('template',{slot:"empty"},[_vm._v(_vm._s(_vm.emptyText))])],2),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(errors[0])}})]}}],null,false,234802319)})],1):_c('bf-form-group',_vm._b({staticClass:"bf-autocomplete",attrs:{"field":_vm.field,"label":_vm.label,"horizontal":_vm.horizontal,"message":_vm.message}},'bf-form-group',_vm.$attrs,false),[_c('b-field',[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])],1)};
var __vue_staticRenderFns__$9 = [];

  /* style */
  const __vue_inject_styles__$a = undefined;
  /* scoped */
  const __vue_scope_id__$a = undefined;
  /* module identifier */
  const __vue_module_identifier__$a = undefined;
  /* functional template */
  const __vue_is_functional_template__$a = false;
  /* component normalizer */
  function __vue_normalize__$a(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfAutocomplete.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfAutocomplete$1 = __vue_normalize__$a(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$a,
    __vue_script__$a,
    __vue_scope_id__$a,
    __vue_is_functional_template__$a,
    __vue_module_identifier__$a,
    undefined,
    undefined
  );

var _a$2, _b$1;
let bfAutocompleteSearch = class bfAutocompleteSearch extends mixins(FormMixin) {
    /**
     * Requests data from the backend based on the prompt in
     * autocompleteSearchObject.model.
     *
     * The data returned from axiosUrl is expected to be an array of type
     * AutocompleteSearchOption
     */
    async getAsyncData(autocompleteSearchField) {
        autocompleteSearchField.data = [];
        autocompleteSearchField.selected = {};
        this.setSelected({});
        autocompleteSearchField.emptyText = 'Searching...';
        await autocompleteSearchField.debouncedMakeRequest(axios, this.axiosUrl);
    }
    /**
     * Triggers the load select in the child bfAutocomplete component
     * @param selected: option selected from available data
     */
    triggerLoadSelected(selected) {
        this.$refs.autocompleteSearchRef.loadSelected(selected);
        this.autocompleteSearchObject.data = [selected];
    }
    /**
     * Updates the data model on the form when an option is selected.
     *
     * Triggered when an option is selected from the dropdown. This is done separately
     * since the field is bound to an AutoCompleteFieldObject, making any updates to the
     * data not propagate directly to the data object used on the form.
     * This ensures that if a data model is passed to the field when initialising, it
     * can be updated as well and the bfAutocompleteSearch field behaves like the rest of
     * the input fields.
     * @param option: option selected from available data
     */
    setSelected(option) {
        if (option !== null && !isEmpty(option)) {
            this.autocompleteSearchObject.selected = option;
            if (this.autocompleteSearchObject.updateModel) {
                this.autocompleteSearchObject.modelToUpdate[this.autocompleteSearchObject.fieldToUpdate] = option.value;
            }
        }
        else {
            this.autocompleteSearchObject.selected = {};
            this.autocompleteSearchObject.modelToUpdate[this.autocompleteSearchObject.fieldToUpdate] = null;
        }
        this.$emit('select');
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a$2 = typeof AutoCompleteFieldObject$$1 !== "undefined" && AutoCompleteFieldObject$$1) === "function" ? _a$2 : Object)
], bfAutocompleteSearch.prototype, "autocompleteSearchObject", void 0);
__decorate([
    Prop({}),
    __metadata("design:type", String)
], bfAutocompleteSearch.prototype, "placeholder", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], bfAutocompleteSearch.prototype, "dataField", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", String)
], bfAutocompleteSearch.prototype, "axiosUrl", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b$1 = typeof Array !== "undefined" && Array) === "function" ? _b$1 : Object)
], bfAutocompleteSearch.prototype, "validate", void 0);
bfAutocompleteSearch = __decorate([
    Component$1({})
], bfAutocompleteSearch);
var script$b = bfAutocompleteSearch;

/* script */
            const __vue_script__$b = script$b;
            
/* template */
var __vue_render__$a = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bf-autocomplete',{ref:"autocompleteSearchRef",attrs:{"label":_vm.label,"field":_vm.field,"validate":{
    required: true,
    autocompleteValidator: {
      dataField: 'display',
      dataDictionary: _vm.autocompleteSearchObject.data,
    },
  },"data":_vm.autocompleteSearchObject.data,"loading":_vm.autocompleteSearchObject.isFetching,"empty-text":_vm.autocompleteSearchObject.emptyText,"placeholder":_vm.placeholder,"data-field":_vm.dataField,"width":"large"},on:{"typing":function($event){return _vm.getAsyncData(_vm.autocompleteSearchObject)},"select":function (option) { return _vm.setSelected(option); }},model:{value:(_vm.autocompleteSearchObject.model),callback:function ($$v) {_vm.$set(_vm.autocompleteSearchObject, "model", $$v);},expression:"autocompleteSearchObject.model"}})};
var __vue_staticRenderFns__$a = [];

  /* style */
  const __vue_inject_styles__$b = undefined;
  /* scoped */
  const __vue_scope_id__$b = "data-v-7ff7f271";
  /* module identifier */
  const __vue_module_identifier__$b = undefined;
  /* functional template */
  const __vue_is_functional_template__$b = false;
  /* component normalizer */
  function __vue_normalize__$b(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfAutocompleteSearch.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfAutocompleteSearch$1 = __vue_normalize__$b(
    { render: __vue_render__$a, staticRenderFns: __vue_staticRenderFns__$a },
    __vue_inject_styles__$b,
    __vue_script__$b,
    __vue_scope_id__$b,
    __vue_is_functional_template__$b,
    __vue_module_identifier__$b,
    undefined,
    undefined
  );

let bfDatepicker = class bfDatepicker extends mixins(FormMixin) {
};
bfDatepicker = __decorate([
    Component({
        components: { bfFormGroup: bfFormGroup$1, ValidationProvider }
    })
], bfDatepicker);
var script$c = bfDatepicker;

/* script */
            const __vue_script__$c = script$c;
            
/* template */
var __vue_render__$b = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bf-form-group',{attrs:{"field":_vm.field,"label":_vm.label,"horizontal":_vm.horizontal,"message":_vm.message}},[_c('ValidationProvider',{attrs:{"vid":_vm.field,"name":_vm.label,"rules":_vm.validate},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var invalid = ref.invalid;
var touched = ref.touched;
return [_c('b-datepicker',_vm._g(_vm._b({class:{
                      invalid: invalid && touched,
                      'input-small': _vm.width === 'small',
                      'input-medium': _vm.width === 'medium',
                      'input-large': _vm.width === 'large'
                  },attrs:{"name":_vm.field,"value":_vm.value,"readonly":false,"editable":true,"placeholder":"YYYY-MM-DD"}},'b-datepicker',_vm.$attrs,false),_vm.$listeners)),_vm._v(" "),_c('span',[_vm._v(_vm._s(errors[0]))])]}}])})],1)};
var __vue_staticRenderFns__$b = [];

  /* style */
  const __vue_inject_styles__$c = undefined;
  /* scoped */
  const __vue_scope_id__$c = undefined;
  /* module identifier */
  const __vue_module_identifier__$c = undefined;
  /* functional template */
  const __vue_is_functional_template__$c = false;
  /* component normalizer */
  function __vue_normalize__$c(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfDatepicker.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfDatepicker$1 = __vue_normalize__$c(
    { render: __vue_render__$b, staticRenderFns: __vue_staticRenderFns__$b },
    __vue_inject_styles__$c,
    __vue_script__$c,
    __vue_scope_id__$c,
    __vue_is_functional_template__$c,
    __vue_module_identifier__$c,
    undefined,
    undefined
  );

let bfForm$1 = class bfForm extends mixins(BaseForm) {
};
__decorate([
    Prop({ default: 'is-centered' }),
    __metadata("design:type", String)
], bfForm$1.prototype, "position", void 0);
__decorate([
    Prop({ default: 'is-beanfield' }),
    __metadata("design:type", String)
], bfForm$1.prototype, "submitClass", void 0);
bfForm$1 = __decorate([
    Component({
        components: { ValidationObserver }
    })
], bfForm$1);
var script$d = bfForm$1;

/* script */
            const __vue_script__$d = script$d;
            
/* template */
var __vue_render__$c = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',{ref:"formRef",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"bf-form",on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[_vm._t("default"),_vm._v(" "),_c('b-field',{attrs:{"position":_vm.position,"grouped":""}},[_c('div',{staticClass:"control"},[_c('button',{staticClass:"button",class:_vm.submitClass,attrs:{"id":("submit-button-" + _vm.formId),"type":"submit"}},[_vm._v(_vm._s(_vm.submitLabel))])]),_vm._v(" "),_c('div',{staticClass:"control"},[_c('a',{staticClass:"button is-medium-dark",on:{"click":function($event){$event.preventDefault();return _vm.$emit('cancel');}}},[_vm._v(" Cancel ")])]),_vm._v(" "),_vm._t("buttons")],2)],2)]}}],null,true)})};
var __vue_staticRenderFns__$c = [];

  /* style */
  const __vue_inject_styles__$d = undefined;
  /* scoped */
  const __vue_scope_id__$d = undefined;
  /* module identifier */
  const __vue_module_identifier__$d = undefined;
  /* functional template */
  const __vue_is_functional_template__$d = false;
  /* component normalizer */
  function __vue_normalize__$d(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfForm.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfForm$2 = __vue_normalize__$d(
    { render: __vue_render__$c, staticRenderFns: __vue_staticRenderFns__$c },
    __vue_inject_styles__$d,
    __vue_script__$d,
    __vue_scope_id__$d,
    __vue_is_functional_template__$d,
    __vue_module_identifier__$d,
    undefined,
    undefined
  );

let bfFormModal = class bfFormModal extends mixins(BaseForm) {
    async onSubmitModal() {
        let response = await this.onSubmit();
        if (response) {
            this.$parent.$parent.close();
        }
    }
};
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], bfFormModal.prototype, "modalTitle", void 0);
__decorate([
    Prop({ default: 'Confirm' }),
    __metadata("design:type", String)
], bfFormModal.prototype, "submitLabel", void 0);
__decorate([
    Prop({ default: 'is-primary' }),
    __metadata("design:type", String)
], bfFormModal.prototype, "submitType", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], bfFormModal.prototype, "cancelLink", void 0);
bfFormModal = __decorate([
    Component({
        components: { ValidationObserver }
    })
], bfFormModal);
var script$e = bfFormModal;

/* script */
            const __vue_script__$e = script$e;
            
/* template */
var __vue_render__$d = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ValidationObserver',{ref:"formRef",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [_c('form',{staticClass:"modal-form",on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmitModal)}}},[_c('div',{staticClass:"modal-card",staticStyle:{"width":"auto"}},[_c('header',{staticClass:"modal-card-head"},[_c('p',{staticClass:"modal-card-title"},[_vm._v(_vm._s(_vm.modalTitle))])]),_vm._v(" "),_c('section',{staticClass:"modal-card-body"},[_vm._t("default")],2),_vm._v(" "),_c('footer',{staticClass:"modal-card-foot"},[_c('button',{staticClass:"button",class:_vm.submitType,attrs:{"id":("submit-button-" + _vm.formId),"type":"submit"}},[_vm._v("\n          "+_vm._s(_vm.submitLabel)+"\n        ")]),_vm._v(" "),(_vm.cancelLink)?_c('a',{staticClass:"cancel-link",on:{"click":function($event){return _vm.$parent.$parent.close();}}},[_vm._v("\n          Cancel\n        ")]):_c('button',{staticClass:"button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$parent.$parent.close();}}},[_vm._v("\n          Cancel\n        ")]),_vm._v(" "),_vm._t("buttons")],2)])])]}}],null,true)})};
var __vue_staticRenderFns__$d = [];

  /* style */
  const __vue_inject_styles__$e = function (inject) {
    if (!inject) return
    inject("data-v-a82bb2f0_0", { source: "\n.modal .animation-content .modal-card[data-v-a82bb2f0]{overflow:visible!important\n}\n.modal-card-body[data-v-a82bb2f0]{overflow:visible!important\n}\n.modal-card-body p[data-v-a82bb2f0]{margin-bottom:1rem\n}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$e = "data-v-a82bb2f0";
  /* module identifier */
  const __vue_module_identifier__$e = undefined;
  /* functional template */
  const __vue_is_functional_template__$e = false;
  /* component normalizer */
  function __vue_normalize__$e(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfFormModal.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    {
      let hook;
      if (style) {
        hook = function(context) {
          style.call(this, createInjector(context));
        };
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render;
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context)
          };
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate;
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const head = document.head || document.getElementsByTagName('head')[0];
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {});
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id;
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

      if (!style.ids.includes(id)) {
        let code = css.source;
        let index = style.ids.length;

        style.ids.push(id);

        if (css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */';
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']');
        }

        if (!style.element) {
          const el = style.element = document.createElement('style');
          el.type = 'text/css';

          if (css.media) el.setAttribute('media', css.media);
          if (isOldIE) {
            el.setAttribute('data-group', group);
            el.setAttribute('data-next-index', '0');
          }

          head.appendChild(el);
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'));
          style.element.setAttribute('data-next-index', index + 1);
        }

        if (style.element.styleSheet) {
          style.parts.push(code);
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n');
        } else {
          const textNode = document.createTextNode(code);
          const nodes = style.element.childNodes;
          if (nodes[index]) style.element.removeChild(nodes[index]);
          if (nodes.length) style.element.insertBefore(textNode, nodes[index]);
          else style.element.appendChild(textNode);
        }
      }
    }
  }
  /* style inject SSR */
  

  
  var bfFormModal$1 = __vue_normalize__$e(
    { render: __vue_render__$d, staticRenderFns: __vue_staticRenderFns__$d },
    __vue_inject_styles__$e,
    __vue_script__$e,
    __vue_scope_id__$e,
    __vue_is_functional_template__$e,
    __vue_module_identifier__$e,
    __vue_create_injector__,
    undefined
  );

let bfInputGroup = class bfInputGroup extends mixins(FormMixin) {
};
__decorate([
    Prop({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], bfInputGroup.prototype, "readonly", void 0);
bfInputGroup = __decorate([
    Component$1({
        components: { bfFormGroup: bfFormGroup$1, ValidationProvider }
    })
], bfInputGroup);
var script$f = bfInputGroup;

/* script */
            const __vue_script__$f = script$f;
            
/* template */
var __vue_render__$e = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.readonly)?_c('bf-form-group',{staticClass:"bf-input-group",attrs:{"field":_vm.field,"label":_vm.label,"horizontal":_vm.horizontal,"message":_vm.message}},[_c('ValidationProvider',{attrs:{"vid":_vm.field,"name":_vm.label,"rules":_vm.validate},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var invalid = ref.invalid;
var touched = ref.touched;
return [_c('b-input',_vm._g(_vm._b({class:{
                 invalid: invalid && touched,
                 'input-small': _vm.width === 'small',
                 'input-medium': _vm.width === 'medium',
                 'input-large': _vm.width === 'large'
             },attrs:{"name":_vm.field,"value":_vm.value,"data-vv-delay":"500"}},'b-input',_vm.$attrs,false),_vm.$listeners)),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(errors[0])}})]}}],null,false,1291830185)})],1):_c('bf-form-group',_vm._b({staticClass:"bf-input-group",attrs:{"field":_vm.field,"label":_vm.label,"horizontal":_vm.horizontal,"message":_vm.message}},'bf-form-group',_vm.$attrs,false),[_c('b-field',[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])],1)};
var __vue_staticRenderFns__$e = [];

  /* style */
  const __vue_inject_styles__$f = undefined;
  /* scoped */
  const __vue_scope_id__$f = undefined;
  /* module identifier */
  const __vue_module_identifier__$f = undefined;
  /* functional template */
  const __vue_is_functional_template__$f = false;
  /* component normalizer */
  function __vue_normalize__$f(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfInputGroup.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfInputGroup$1 = __vue_normalize__$f(
    { render: __vue_render__$e, staticRenderFns: __vue_staticRenderFns__$e },
    __vue_inject_styles__$f,
    __vue_script__$f,
    __vue_scope_id__$f,
    __vue_is_functional_template__$f,
    __vue_module_identifier__$f,
    undefined,
    undefined
  );

let bfGroup = class bfGroup extends Vue {
};
__decorate([
    Prop({ required: true, type: String }),
    __metadata("design:type", String)
], bfGroup.prototype, "label", void 0);
__decorate([
    Prop({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], bfGroup.prototype, "horizontal", void 0);
__decorate([
    Prop({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], bfGroup.prototype, "hideColon", void 0);
bfGroup = __decorate([
    Component({})
], bfGroup);
var script$g = bfGroup;

/* script */
            const __vue_script__$g = script$g;
            
/* template */
var __vue_render__$f = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-field',{staticClass:"bf-output-group",attrs:{"label":("" + _vm.label + (_vm.hideColon ? '' : ':')),"horizontal":_vm.horizontal}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$f = [];

  /* style */
  const __vue_inject_styles__$g = undefined;
  /* scoped */
  const __vue_scope_id__$g = undefined;
  /* module identifier */
  const __vue_module_identifier__$g = undefined;
  /* functional template */
  const __vue_is_functional_template__$g = false;
  /* component normalizer */
  function __vue_normalize__$g(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfOutputGroup.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfOutputGroup = __vue_normalize__$g(
    { render: __vue_render__$f, staticRenderFns: __vue_staticRenderFns__$f },
    __vue_inject_styles__$g,
    __vue_script__$g,
    __vue_scope_id__$g,
    __vue_is_functional_template__$g,
    __vue_module_identifier__$g,
    undefined,
    undefined
  );

let bfSearchForm = class bfSearchForm extends mixins(FormMixin) {
    constructor() {
        super(...arguments);
        this.internalQuery = '';
        this.internalShowAdvanced = this.showAdvanced;
    }
    onQueryChange() {
        //This is to update the parent component query if you use :query.sync="query"
        this.$emit('update:query', this.internalQuery);
    }
    onShowAdvancedChange() {
        //This is to update the parent component showAdvanced if you use :show-advanced.sync="showAdvanced"
        this.$emit('update:showAdvanced', this.internalShowAdvanced);
    }
    formSearch() {
        this.$emit('search', {
            query: this.internalQuery,
            showAdvanced: this.internalShowAdvanced
        });
    }
};
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], bfSearchForm.prototype, "showAdvanced", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], bfSearchForm.prototype, "useSearchButton", void 0);
__decorate([
    Prop({ default: 'magnify' }),
    __metadata("design:type", String)
], bfSearchForm.prototype, "icon", void 0);
__decorate([
    Prop({ default: 'Search...' }),
    __metadata("design:type", String)
], bfSearchForm.prototype, "placeholder", void 0);
__decorate([
    Watch('internalQuery'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], bfSearchForm.prototype, "onQueryChange", null);
__decorate([
    Watch('internalShowAdvanced'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], bfSearchForm.prototype, "onShowAdvancedChange", null);
bfSearchForm = __decorate([
    Component$1({})
], bfSearchForm);
var script$h = bfSearchForm;

/* script */
            const __vue_script__$h = script$h;
            
/* template */
var __vue_render__$g = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bf-search-form"},[_c('form',{staticClass:"bf-search-input",on:{"submit":function($event){$event.preventDefault();return _vm.formSearch($event)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.internalQuery),expression:"internalQuery"}],staticClass:"form-text-search",attrs:{"label":_vm.label,"placeholder":_vm.placeholder,"name":"searchText","type":"search"},domProps:{"value":(_vm.internalQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.internalQuery=$event.target.value;}}}),_vm._v(" "),_c('p',{staticClass:"control"},[_c('button',{staticClass:"button is-primary search-icon",on:{"click":function($event){$event.preventDefault();return _vm.formSearch($event)}}},[_c('b-icon',{attrs:{"icon":_vm.icon}})],1)])]),_vm._v(" "),_c('b-collapse',{staticClass:"form-collapse-link",attrs:{"open":_vm.internalShowAdvanced},on:{"update:open":function($event){_vm.internalShowAdvanced=$event;}}},[_c('a',{attrs:{"slot":"trigger"},slot:"trigger"},[_vm._v("Advanced Search")]),_vm._v(" "),_vm._t("default")],2)],1)};
var __vue_staticRenderFns__$g = [];

  /* style */
  const __vue_inject_styles__$h = function (inject) {
    if (!inject) return
    inject("data-v-bd8be32a_0", { source: "\n.bf-search-form[data-v-bd8be32a]{display:flex;flex-direction:column\n}\n.bf-search-form .bf-search-input[data-v-bd8be32a]{display:flex;align-items:center\n}\n.bf-search-form .bf-search-input .form-text-search[data-v-bd8be32a]{flex-grow:1;padding:calc(.375em + 2px) .75em;font-size:14px;border:1px solid #bababa;box-sizing:border-box;box-shadow:inset 0 1px 1px rgba(0,0,0,.075);border-radius:4px 0 0 4px;font-family:'Open Sans';color:#7d7d7d\n}\n.bf-search-form .bf-search-input p.control button.search-icon[data-v-bd8be32a]{border-radius:0 4px 4px 0\n}\n.bf-search-form .bf-search-input[data-v-bd8be32a] ::placeholder{color:#bababa;font-family:'Open Sans'\n}\n.bf-search-form .bf-search-input[data-v-bd8be32a] :-moz-placeholder{color:#bababa;opacity:1;font-family:'Open Sans'\n}\n.bf-search-form .bf-search-input[data-v-bd8be32a] ::-moz-placeholder{color:#bababa;opacity:1;font-family:'Open Sans'\n}\n.bf-search-form .form-collapse-link[data-v-bd8be32a]{text-align:right\n}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$h = "data-v-bd8be32a";
  /* module identifier */
  const __vue_module_identifier__$h = undefined;
  /* functional template */
  const __vue_is_functional_template__$h = false;
  /* component normalizer */
  function __vue_normalize__$h(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfSearchForm.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    {
      let hook;
      if (style) {
        hook = function(context) {
          style.call(this, createInjector(context));
        };
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render;
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context)
          };
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate;
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__$1() {
    const head = document.head || document.getElementsByTagName('head')[0];
    const styles = __vue_create_injector__$1.styles || (__vue_create_injector__$1.styles = {});
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id;
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

      if (!style.ids.includes(id)) {
        let code = css.source;
        let index = style.ids.length;

        style.ids.push(id);

        if (css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */';
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']');
        }

        if (!style.element) {
          const el = style.element = document.createElement('style');
          el.type = 'text/css';

          if (css.media) el.setAttribute('media', css.media);
          if (isOldIE) {
            el.setAttribute('data-group', group);
            el.setAttribute('data-next-index', '0');
          }

          head.appendChild(el);
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'));
          style.element.setAttribute('data-next-index', index + 1);
        }

        if (style.element.styleSheet) {
          style.parts.push(code);
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n');
        } else {
          const textNode = document.createTextNode(code);
          const nodes = style.element.childNodes;
          if (nodes[index]) style.element.removeChild(nodes[index]);
          if (nodes.length) style.element.insertBefore(textNode, nodes[index]);
          else style.element.appendChild(textNode);
        }
      }
    }
  }
  /* style inject SSR */
  

  
  var bfSearchForm$1 = __vue_normalize__$h(
    { render: __vue_render__$g, staticRenderFns: __vue_staticRenderFns__$g },
    __vue_inject_styles__$h,
    __vue_script__$h,
    __vue_scope_id__$h,
    __vue_is_functional_template__$h,
    __vue_module_identifier__$h,
    __vue_create_injector__$1,
    undefined
  );

let bfSelect = class bfSelect extends mixins(FormMixin) {
};
__decorate([
    Prop(Array),
    __metadata("design:type", Array)
], bfSelect.prototype, "options", void 0);
__decorate([
    Prop({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], bfSelect.prototype, "readonly", void 0);
bfSelect = __decorate([
    Component$1({
        components: { bfFormGroup: bfFormGroup$1, ValidationProvider }
    })
], bfSelect);
var script$i = bfSelect;

/* script */
            const __vue_script__$i = script$i;
            
/* template */
var __vue_render__$h = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.readonly)?_c('bf-form-group',{staticClass:"bf-select",attrs:{"field":_vm.field,"label":_vm.label,"horizontal":_vm.horizontal,"message":_vm.message}},[_c('ValidationProvider',{attrs:{"vid":_vm.field,"name":_vm.label,"rules":_vm.validate},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var invalid = ref.invalid;
var touched = ref.touched;
return [_c('b-select',_vm._g(_vm._b({class:{
                  invalid: invalid && touched,
                  'input-small': _vm.width === 'small',
                  'input-medium': _vm.width === 'medium',
                  'input-large': _vm.width === 'large'
              },attrs:{"name":_vm.field,"value":_vm.value}},'b-select',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_vm._v(" "),(_vm.options)?_vm._l((_vm.options),function(option,idx){return _c('option',{key:idx,domProps:{"value":option.value}},[_vm._v("\n          "+_vm._s(option.label)+"\n        ")])}):_vm._e()],2),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(errors[0])}})]}}],null,true)})],1):_c('bf-form-group',_vm._b({staticClass:"bf-select",attrs:{"field":_vm.field,"label":_vm.label,"horizontal":_vm.horizontal,"message":_vm.message}},'bf-form-group',_vm.$attrs,false),[_c('b-field',[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])],1)};
var __vue_staticRenderFns__$h = [];

  /* style */
  const __vue_inject_styles__$i = undefined;
  /* scoped */
  const __vue_scope_id__$i = undefined;
  /* module identifier */
  const __vue_module_identifier__$i = undefined;
  /* functional template */
  const __vue_is_functional_template__$i = false;
  /* component normalizer */
  function __vue_normalize__$i(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfSelect.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfSelect$1 = __vue_normalize__$i(
    { render: __vue_render__$h, staticRenderFns: __vue_staticRenderFns__$h },
    __vue_inject_styles__$i,
    __vue_script__$i,
    __vue_scope_id__$i,
    __vue_is_functional_template__$i,
    __vue_module_identifier__$i,
    undefined,
    undefined
  );

let bfTimepicker = class bfTimepicker extends mixins(FormMixin) {
    constructor() {
        super(...arguments);
        this.maxHour = this.max;
        this.newValue = this.value;
        this.timeOptions = [];
        this.today = new Date();
        this.unselectedMessage = '';
    }
    onValueChange() {
        this.newValue = this.value;
    }
    created() {
        if (this.max < this.min) {
            this.maxHour = this.min;
        }
        for (let hour = this.min; hour <= this.maxHour; hour++) {
            for (let minute = 0; minute < 60; minute += this.intervalMinute) {
                this.timeOptions.push(format(this.today.setHours(hour, minute, 0, 0), this.timeFormat));
            }
        }
    }
    checkValid(value) {
        if (!this.filteredTimeOptions.length) {
            this.newValue = '';
        }
    }
    get filteredTimeOptions() {
        return this.timeOptions.filter(option => {
            return option.toString().indexOf(this.newValue) >= 0;
        });
    }
    get formMessage() {
        return this.unselectedMessage === ''
            ? this.message
            : this.unselectedMessage;
    }
    /*
     * Format original ISO time string to passed timeFormat.
     */
    formatTimestring(value) {
        if (!value) {
            this.newValue = '';
        }
        else {
            let date = parse(format(this.today, 'YYYY-MM-DD ') + value);
            if (date && !isNaN(date)) {
                this.newValue = format(date, this.timeFormat);
            }
            else {
                this.newValue = '';
            }
        }
    }
    mounted() {
        this.formatTimestring(this.value);
    }
    optionSelected(event) {
        if (event === null) {
            this.unselectedMessage = 'Option not selected';
        }
        else {
            this.unselectedMessage = '';
            this.newValue = event;
        }
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Object)
], bfTimepicker.prototype, "dataField", void 0);
__decorate([
    Prop({
        default: 15,
        validator: function (val) {
            return val > 0 && val <= 60;
        }
    }),
    __metadata("design:type", Number)
], bfTimepicker.prototype, "intervalMinute", void 0);
__decorate([
    Prop({
        default: 23,
        validator: function (val) {
            return val >= 0 && val < 24;
        }
    }),
    __metadata("design:type", Number)
], bfTimepicker.prototype, "max", void 0);
__decorate([
    Prop({
        default: 0,
        validator: function (val) {
            return val >= 0 && val < 24;
        }
    }),
    __metadata("design:type", Number)
], bfTimepicker.prototype, "min", void 0);
__decorate([
    Prop({ default: 'hh:mm A' }),
    __metadata("design:type", String)
], bfTimepicker.prototype, "timeFormat", void 0);
__decorate([
    Watch('value'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], bfTimepicker.prototype, "onValueChange", null);
bfTimepicker = __decorate([
    Component$1({
        components: { bfFormGroup: bfFormGroup$1, ValidationProvider }
    })
], bfTimepicker);
var script$j = bfTimepicker;

/* script */
            const __vue_script__$j = script$j;
            
/* template */
var __vue_render__$i = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.readonly)?_c('bf-form-group',{staticClass:"bf-timepicker",attrs:{"field":_vm.field,"label":_vm.label,"horizontal":_vm.horizontal,"message":_vm.formMessage}},[_c('ValidationProvider',{attrs:{"vid":_vm.field,"name":_vm.label,"rules":_vm.validate},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var invalid = ref.invalid;
var touched = ref.touched;
return [_c('b-autocomplete',_vm._g(_vm._b({class:{invalid: invalid && touched},attrs:{"name":_vm.field,"value":_vm.newValue,"field":_vm.dataField,"data":_vm.filteredTimeOptions,"open-on-focus":true,"keep-first":true},on:{"select":_vm.optionSelected,"blur":function($event){return _vm.checkValid(_vm.value)}}},'b-autocomplete',_vm.$attrs,false),_vm.$listeners)),_vm._v(" "),_c('span',[_vm._v(_vm._s(errors[0]))])]}}],null,false,3882161872)})],1):_c('bf-form-group',_vm._b({staticClass:"bf-autocomplete",attrs:{"field":_vm.field,"label":_vm.label,"horizontal":_vm.horizontal,"message":_vm.message}},'bf-form-group',_vm.$attrs,false),[_c('b-field',[_vm._v("\n    "+_vm._s(_vm.newValue)+"\n  ")])],1)};
var __vue_staticRenderFns__$i = [];

  /* style */
  const __vue_inject_styles__$j = undefined;
  /* scoped */
  const __vue_scope_id__$j = undefined;
  /* module identifier */
  const __vue_module_identifier__$j = undefined;
  /* functional template */
  const __vue_is_functional_template__$j = false;
  /* component normalizer */
  function __vue_normalize__$j(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfTimepicker.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfTimepicker$1 = __vue_normalize__$j(
    { render: __vue_render__$i, staticRenderFns: __vue_staticRenderFns__$i },
    __vue_inject_styles__$j,
    __vue_script__$j,
    __vue_scope_id__$j,
    __vue_is_functional_template__$j,
    __vue_module_identifier__$j,
    undefined,
    undefined
  );

var _a$3;
let bfBreadcrumbs = class bfBreadcrumbs extends Vue {
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a$3 = typeof Array !== "undefined" && Array) === "function" ? _a$3 : Object)
], bfBreadcrumbs.prototype, "crumbs", void 0);
bfBreadcrumbs = __decorate([
    Component({})
], bfBreadcrumbs);
var script$k = bfBreadcrumbs;

/* script */
            const __vue_script__$k = script$k;
            
/* template */
var __vue_render__$j = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bf-breadcrumbs breadcrumbs"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"breadcrumb",attrs:{"aria-label":"breadcrumbs"}},[_c('ul',[_vm._l((_vm.crumbs),function(crumb,idx){return _c('li',{key:idx},[(crumb.external)?_c('a',{class:{'is-active': (idx === _vm.crumbs.length - 1)},attrs:{"href":crumb.link.indexOf('http') ? crumb.link : _vm.window.location.hostname + crumb.link,"active-class":""}},[_vm._v(_vm._s(crumb.title))]):_c('nuxt-link',{class:{'is-active': (idx === _vm.crumbs.length - 1)},attrs:{"to":crumb.link,"active-class":""}},[_vm._v(_vm._s(crumb.title))])],1)}),_vm._v(" "),_vm._t("default")],2)])])])};
var __vue_staticRenderFns__$j = [];

  /* style */
  const __vue_inject_styles__$k = undefined;
  /* scoped */
  const __vue_scope_id__$k = undefined;
  /* module identifier */
  const __vue_module_identifier__$k = undefined;
  /* functional template */
  const __vue_is_functional_template__$k = false;
  /* component normalizer */
  function __vue_normalize__$k(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfBreadcrumbs.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfBreadcrumbs$1 = __vue_normalize__$k(
    { render: __vue_render__$j, staticRenderFns: __vue_staticRenderFns__$j },
    __vue_inject_styles__$k,
    __vue_script__$k,
    __vue_scope_id__$k,
    __vue_is_functional_template__$k,
    __vue_module_identifier__$k,
    undefined,
    undefined
  );

let bfNavbar = class bfNavbar extends Vue {
    constructor() {
        super(...arguments);
        this.showDropdown = false;
        this.showDesktopDropdown = false;
    }
};
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], bfNavbar.prototype, "hasDesktopHamburger", void 0);
__decorate([
    Prop({ default: '/' }),
    __metadata("design:type", String)
], bfNavbar.prototype, "rootLink", void 0);
bfNavbar = __decorate([
    Component$1({})
], bfNavbar);
var script$l = bfNavbar;

/* script */
            const __vue_script__$l = script$l;
            
/* template */
var __vue_render__$k = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navbar-container bf-navbar"},[_c('nav',{staticClass:"navbar",attrs:{"role":"navigation","aria-label":"main navigation"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-brand"},[_c('nuxt-link',{staticClass:"navbar-item image logo",attrs:{"to":_vm.rootLink,"active-class":"active-ignore"}},[_vm._t("logo",[_vm._v("\n            Beanfield\n          ")])],2),_vm._v(" "),_c('button',{staticClass:"button navbar-burger",class:{ 'is-active': _vm.showDropdown },on:{"click":function($event){_vm.showDropdown = !_vm.showDropdown;}}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])],1),_vm._v(" "),_c('div',{staticClass:"navbar-menu",class:{'is-active': _vm.showDropdown }},[_vm._t("default")],2)])]),_vm._v(" "),(_vm.hasDesktopHamburger)?_c('div',{staticClass:"desktop-menu is-hidden-touch",class:{ 'is-active': _vm.showDesktopDropdown }},[_c('button',{staticClass:"button navbar-burger",class:{ 'is-active': _vm.showDesktopDropdown },on:{"click":function($event){_vm.showDesktopDropdown = !_vm.showDesktopDropdown;}}},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),_c('div',{staticClass:"navbar-menu",class:{'is-active': _vm.showDesktopDropdown }},[_vm._t("desktop-menu")],2)]):_vm._e()])};
var __vue_staticRenderFns__$k = [];

  /* style */
  const __vue_inject_styles__$l = function (inject) {
    if (!inject) return
    inject("data-v-456f0ed1_0", { source: "\n.logo[data-v-456f0ed1]{margin-right:30px\n}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$l = "data-v-456f0ed1";
  /* module identifier */
  const __vue_module_identifier__$l = undefined;
  /* functional template */
  const __vue_is_functional_template__$l = false;
  /* component normalizer */
  function __vue_normalize__$l(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfNavbar.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    {
      let hook;
      if (style) {
        hook = function(context) {
          style.call(this, createInjector(context));
        };
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render;
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context)
          };
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate;
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__$2() {
    const head = document.head || document.getElementsByTagName('head')[0];
    const styles = __vue_create_injector__$2.styles || (__vue_create_injector__$2.styles = {});
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id;
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

      if (!style.ids.includes(id)) {
        let code = css.source;
        let index = style.ids.length;

        style.ids.push(id);

        if (css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */';
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']');
        }

        if (!style.element) {
          const el = style.element = document.createElement('style');
          el.type = 'text/css';

          if (css.media) el.setAttribute('media', css.media);
          if (isOldIE) {
            el.setAttribute('data-group', group);
            el.setAttribute('data-next-index', '0');
          }

          head.appendChild(el);
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'));
          style.element.setAttribute('data-next-index', index + 1);
        }

        if (style.element.styleSheet) {
          style.parts.push(code);
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n');
        } else {
          const textNode = document.createTextNode(code);
          const nodes = style.element.childNodes;
          if (nodes[index]) style.element.removeChild(nodes[index]);
          if (nodes.length) style.element.insertBefore(textNode, nodes[index]);
          else style.element.appendChild(textNode);
        }
      }
    }
  }
  /* style inject SSR */
  

  
  var bfNavbar$1 = __vue_normalize__$l(
    { render: __vue_render__$k, staticRenderFns: __vue_staticRenderFns__$k },
    __vue_inject_styles__$l,
    __vue_script__$l,
    __vue_scope_id__$l,
    __vue_is_functional_template__$l,
    __vue_module_identifier__$l,
    __vue_create_injector__$2,
    undefined
  );

let bfExternalUrl = class bfExternalUrl extends Vue {
    get link() {
        if (process['browser']) {
            const curLocation = window.location;
            const curHost = curLocation.host.slice(curLocation.host.indexOf('.') + 1);
            const linkEl = document.createElement('a');
            linkEl.href = this.href;
            const subdomain = linkEl.hostname.split('.')[0];
            return `\
      ${curLocation.protocol}//${subdomain}.${curHost}${linkEl.pathname}\
      ${linkEl.search}${linkEl.hash}\
      `;
        }
        else {
            return this.href;
        }
    }
};
__decorate([
    Prop({ required: true, type: String }),
    __metadata("design:type", Object)
], bfExternalUrl.prototype, "href", void 0);
bfExternalUrl = __decorate([
    Component({})
], bfExternalUrl);
var script$m = bfExternalUrl;

/* script */
            const __vue_script__$m = script$m;
            
/* template */
var __vue_render__$l = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"bf-internal-link",attrs:{"href":_vm.link}},[_vm._t("default")],2)};
var __vue_staticRenderFns__$l = [];

  /* style */
  const __vue_inject_styles__$m = undefined;
  /* scoped */
  const __vue_scope_id__$m = undefined;
  /* module identifier */
  const __vue_module_identifier__$m = undefined;
  /* functional template */
  const __vue_is_functional_template__$m = false;
  /* component normalizer */
  function __vue_normalize__$m(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfExternalUrl.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  

  
  var bfExternalUrl$1 = __vue_normalize__$m(
    { render: __vue_render__$l, staticRenderFns: __vue_staticRenderFns__$l },
    __vue_inject_styles__$m,
    __vue_script__$m,
    __vue_scope_id__$m,
    __vue_is_functional_template__$m,
    __vue_module_identifier__$m,
    undefined,
    undefined
  );

let bfTable = class bfTable extends Vue$1 {
    constructor() {
        super(...arguments);
        this.page = 1;
        this.data = [];
        this.totalItems = 0;
        this.sortKey = null;
        this.sortDir = null;
    }
    onQueryChange() {
        this.onPageChange(this.page);
    }
    onExtraParamsChange() {
        this.onPageChange(this.page);
    }
    mounted() {
        this.sortKey = this.initialSortKey;
        this.sortDir = this.initialSortDir;
        this.onPageChange(1);
    }
    async onPageChange(page) {
        const searchParams = {
            page: page,
            items_per_page: this.itemsPerPage,
            q: this.query,
            sort: this.sortKey,
            desc: this.sortDir === 'desc'
        };
        let params = {};
        params = Object.assign({}, searchParams, this.extraParams);
        const response = await this.$axios.get(this.url, {
            params: params
        });
        if (response.status === 200) {
            const data = response.data;
            this.data = data.data;
            this.page = data.page;
            this.totalItems = data.item_count;
        }
    }
    onSort(field, order) {
        this.sortKey = field;
        this.sortDir = order;
        this.onPageChange(this.page);
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", String)
], bfTable.prototype, "url", void 0);
__decorate([
    Prop({
        default: () => {
            return {};
        }
    }),
    __metadata("design:type", Object)
], bfTable.prototype, "extraParams", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], bfTable.prototype, "initialSortKey", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], bfTable.prototype, "initialSortDir", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], bfTable.prototype, "query", void 0);
__decorate([
    Prop({ default: 20 }),
    __metadata("design:type", Number)
], bfTable.prototype, "itemsPerPage", void 0);
__decorate([
    Watch('query'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], bfTable.prototype, "onQueryChange", null);
__decorate([
    Watch('extraParams'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], bfTable.prototype, "onExtraParamsChange", null);
bfTable = __decorate([
    Component({})
], bfTable);
var script$n = bfTable;

/* script */
            const __vue_script__$n = script$n;
            
/* template */
var __vue_render__$m = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-table',{attrs:{"data":_vm.data,"total":_vm.totalItems,"per-page":_vm.itemsPerPage,"default-sort":_vm.initialSortKey !== null ? [_vm.initialSortKey, _vm.initialSortDir] : null,"backend-pagination":"","backend-sorting":""},on:{"page-change":_vm.onPageChange,"sort":_vm.onSort},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._t("default",null,{"row":row,"index":index})]}}],null,true)}),_vm._v(" "),_c('div',{staticClass:"bf-pagination"},[_c('b-pagination',{attrs:{"current":_vm.page,"per-page":_vm.itemsPerPage,"total":_vm.totalItems,"order":"is-centered"},on:{"change":_vm.onPageChange}})],1)],1)};
var __vue_staticRenderFns__$m = [];

  /* style */
  const __vue_inject_styles__$n = function (inject) {
    if (!inject) return
    inject("data-v-3075a858_0", { source: "\n@media screen and (min-width:1216px){\n.bf-pagination[data-v-3075a858]{width:40%;margin-left:30%\n}\n}\n@media screen and (min-width:769px){\n.bf-pagination[data-v-3075a858]{width:60%;margin-left:20%\n}\n}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$n = "data-v-3075a858";
  /* module identifier */
  const __vue_module_identifier__$n = undefined;
  /* functional template */
  const __vue_is_functional_template__$n = false;
  /* component normalizer */
  function __vue_normalize__$n(
    template, style, script,
    scope, functional, moduleIdentifier,
    createInjector, createInjectorSSR
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {};

    // For security concerns, we use only base name in production mode.
    component.__file = "bfTable.vue";

    if (!component.render) {
      component.render = template.render;
      component.staticRenderFns = template.staticRenderFns;
      component._compiled = true;

      if (functional) component.functional = true;
    }

    component._scopeId = scope;

    {
      let hook;
      if (style) {
        hook = function(context) {
          style.call(this, createInjector(context));
        };
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render;
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context);
            return originalRender(h, context)
          };
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate;
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__$3() {
    const head = document.head || document.getElementsByTagName('head')[0];
    const styles = __vue_create_injector__$3.styles || (__vue_create_injector__$3.styles = {});
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id;
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined });

      if (!style.ids.includes(id)) {
        let code = css.source;
        let index = style.ids.length;

        style.ids.push(id);

        if (css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */';
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']');
        }

        if (!style.element) {
          const el = style.element = document.createElement('style');
          el.type = 'text/css';

          if (css.media) el.setAttribute('media', css.media);
          if (isOldIE) {
            el.setAttribute('data-group', group);
            el.setAttribute('data-next-index', '0');
          }

          head.appendChild(el);
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'));
          style.element.setAttribute('data-next-index', index + 1);
        }

        if (style.element.styleSheet) {
          style.parts.push(code);
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n');
        } else {
          const textNode = document.createTextNode(code);
          const nodes = style.element.childNodes;
          if (nodes[index]) style.element.removeChild(nodes[index]);
          if (nodes.length) style.element.insertBefore(textNode, nodes[index]);
          else style.element.appendChild(textNode);
        }
      }
    }
  }
  /* style inject SSR */
  

  
  var bfTable$1 = __vue_normalize__$n(
    { render: __vue_render__$m, staticRenderFns: __vue_staticRenderFns__$m },
    __vue_inject_styles__$n,
    __vue_script__$n,
    __vue_scope_id__$n,
    __vue_is_functional_template__$n,
    __vue_module_identifier__$n,
    __vue_create_injector__$3,
    undefined
  );



var components = /*#__PURE__*/Object.freeze({
    bfAccountMenu: bfAccountMenu$1,
    bfAlert: bfAlert$1,
    bfContentHeader: bfContentHeader$1,
    bfPageHeader: bfPageHeader$1,
    bfPanel: bfPanel$1,
    bfSectionHeader: bfSectionHeader$1,
    bfFormatDate: bfFormatDate$1,
    bfFormatBoolean: bfFormatBoolean$1,
    BaseForm: BaseForm,
    bfAutocomplete: bfAutocomplete$1,
    bfAutocompleteSearch: bfAutocompleteSearch$1,
    bfDatepicker: bfDatepicker$1,
    bfForm: bfForm$2,
    bfFormGroup: bfFormGroup$1,
    bfFormModal: bfFormModal$1,
    bfInputGroup: bfInputGroup$1,
    bfOutputGroup: bfOutputGroup,
    bfSearchForm: bfSearchForm$1,
    bfSelect: bfSelect$1,
    bfTimepicker: bfTimepicker$1,
    bfBreadcrumbs: bfBreadcrumbs$1,
    bfNavbar: bfNavbar$1,
    bfExternalUrl: bfExternalUrl$1,
    bfTable: bfTable$1
});

const Vui = {
    install(Vue$$1, options) {
        // To use your own config for these plugins, install them with Vue.use
        // in your own project before installing vui.
        Vue$$1.use(VeeValidate, {
            inject: false
        });
        Vue$$1.use(Buefy, {
            defaultDateFormatter: date => Moment(date).format('YYYY-MM-DD'),
            defaultDateParser: date => {
                const m = Moment(date);
                return m.isValid() ? m.toDate() : null;
            }
        });
        for (let key in components) {
            Vue$$1.component(key, components[key]);
        }
    }
};
// importing rules that are used from for vee-validate for validation
// https://logaretm.github.io/vee-validate/guide/rules.html#importing-the-rules
extend('email', email);
extend('required', required);
extend('numeric', {
    ...numeric,
    message: 'The {_field_} field may only contain numeric characters'
});
extend('min', {
    validate(value, { length }) {
        return value.length >= length;
    },
    params: ['length'],
    message: 'The {_field_} field must have at least {length} characters'
});
extend('max', {
    validate(value, { length }) {
        return value.length < length;
    },
    params: ['length'],
    message: 'The {_field_} field must have less than {length} characters'
});
extend('autocompleteValidator', {
    message: field => 'For ' + field + ' please choose from the available options',
    // @ts-ignore
    validate(value, { dataField, dataDictionary }) {
        for (let i = 0; i < dataDictionary.length; i++) {
            if (dataDictionary[i][dataField] === value) {
                return true;
            }
        }
        return false;
    },
    params: ['dataField', 'dataDictionary']
});
// Install vee-validate's English and French locales.
localize({ en, fr });

export default Vui;
export { Crumb };
